export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تنشيط الشيك الإلكتروني"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حساب الائتمان"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الرقم"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["السلسلة"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رمز التنشيط"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تحقق"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تنشيط"])}
}